import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  resentOtpApi,
  sendOtpApi,
  socialSignUpApi,
  verifyOtpApi,
  verifyOtpWidjetApi,
} from "../api/OtpAuthAPI";

// Async thunks for API calls
export const sendOtp = createAsyncThunk(
  "auth/sendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await sendOtpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await verifyOtpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const resendOtp = createAsyncThunk(
  "auth/resendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await resentOtpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const verifyWidjetOtp = createAsyncThunk(
  "auth/verifyWidjetOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await verifyOtpWidjetApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const socialSignUp = createAsyncThunk(
  "auth/socialSignUp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await socialSignUpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

// Initial state
const initialState = {
  otp: "",
  loading: false,
  resentloading: false,
  error: null,
  isOtpVerified: false,
};

// Slice definition
const otpAuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetOtp: (state) => {
      state.otp = "";
      state.isOtpVerified = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendOtp.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.isOtpVerified = true;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(resendOtp.pending, (state) => {
        state.resentloading = true;
      })
      .addCase(resendOtp.fulfilled, (state) => {
        state.resentloading = false;
      })
      .addCase(resendOtp.rejected, (state, action) => {
        state.resentloading = false;
        state.error = action.error.message;
      })
      .addCase(verifyWidjetOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyWidjetOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.isOtpVerified = true;
      })
      .addCase(verifyWidjetOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(socialSignUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(socialSignUp.fulfilled, (state, action) => {
        state.loading = false;
        state.isOtpVerified = true;
      })
      .addCase(socialSignUp.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default otpAuthSlice.reducer;
